import React from 'react';
import { Card, CardBody, Col } from 'reactstrap';
import { Pie } from 'react-chartjs-2';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

const LegendHandlers = (props) => {
  const { chartTitle, dataLabels, numbersChart, options } = props;

  const data = {
    labels: dataLabels,
    datasets: [
      {
        data: numbersChart,
        backgroundColor: [
          '#FF708B',
          '#FFBA6A',
          '#01F1E3',
          '#9c2dd2',
          '#D4a3ee',
        ],
        hoverBackgroundColor: ['#FF708B', '#FFBA6A'],
        borderColor: 'rgba(255,255,255,0.54)',
      },
    ],
  };

  const legendOptions = {
    display: true,
    position: 'right',
    onClick: () => {},
  };

  return (
    <Col md={12} lg={12} xl={12}>
      <Card>
        <CardBody>
          <div className="card__title">
            <h5 className="bold-text">{chartTitle}</h5>
          </div>
          <Pie data={data} legend={legendOptions} options={options} />
        </CardBody>
      </Card>
    </Col>
  );
};

LegendHandlers.propTypes = {
  chartTitle: PropTypes.string,
  dataLabels: PropTypes.arrayOf(PropTypes.shape),
  numbersChart: PropTypes.arrayOf(PropTypes.shape).isRequired,
  options: PropTypes.shape(PropTypes.shape),
};

LegendHandlers.defaultProps = {
  chartTitle: '',
  dataLabels: [],
  options: {},
};

export default withTranslation('common')(LegendHandlers);
